import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: "33.5rem",
  },
  headFont: {
    fontWeight: "bold",
    fontSize: "2rem",
  },
  dataCell: {
    cursor: "pointer",
    "&:hover": {
      color: theme.palette.primary.light,
    },
  },
  weightCell: {
    width: "3.5vw !important",
  },
  featureCell: {
    width: "5vw !important",
  },
  headInputCell: {
    width: "3.5vw !important",
    backgroundColor: "#f4f4f4 !important",
  },
  inputCell: {
    width: "3.5vw !important",
    backgroundColor: "rgba(218, 218, 218, 0.30) !important",
  },
  paramCell: {
    padding: "0.5rem 0",
    width: "12vw",
  },
  greyCell: {
    backgroundColor: "rgba(134, 134, 134, 0.31) !important",
  },
}));

export default useStyles;
